<template>
    <div>
        <div v-if="header">
            <div
                class="navigation-header" style="width: 530px">
                <div class = "navigation-col-header remove-button pl-4">
                    <v-icon>mdi-trash-can-outline</v-icon>
                </div>
                <div class = "navigation-col-header elevator pl-8">
                    {{ $t('inc.unit.elevatorNo') }}
                </div>
                <div class = "navigation-col-header amount pr-2">
                    {{ $t('invoice.cost.net') }}
                </div>
                <div class = "navigation-col-header correction pr-2">
                    {{ $t('invoice.cost.correction') }}
                </div>
            </div>
        </div>

        <v-hover
            v-if   = "!header"
            v-slot = "{ hover }"
        >
            <div
                v-if="unit"
                class="navigation-entry"
                :class ="border2"
            >
                <div
                    class="remove-button"
                    :class = "background(hover)"
                >
                    <a @click="onRemove">
                        <v-icon color="error" class="toolbar-button" size="20">mdi-minus-box</v-icon>
                    </a>
                </div>
                <div
                    class  = "elevator v-flex"
                    :class = "background(hover)"
                >
                    <v-icon style="margin-top: -5px" :color="hover? 'white' : 'primary'" size="16">{{ entry.status.font }} {{ 'fa-' + entry.status.symbol}}</v-icon>
                    <div class="pl-2">{{ unit.fabricNo }}</div>
                </div>
                <div
                    class  = "pr-2 amount"
                    :class = "background(hover)"
                >
                    {{ amount }}
                </div>
                <div
                    class  = "pr-2 correction"
                    :class = "background(hover)"
                >
                    <v-icon v-if="correction !== '---'" style="margin-top: -1px">mdi-delta</v-icon> {{ correction }}
                </div>
            </div>
        </v-hover>
    </div>
</template>

<script>

import PIncNavigationMixin from "@/modules/inc/steps/components/navigation/private/PIncNavigationMixin";

export default {
    name: "PIncNavigationEntryInvoice",

    components: {
    },

    mixins: [
        PIncNavigationMixin
    ],

    computed: {
        amount () {
            if (!this.entry.item_1) {
                return "---";
            }

            return this.moneyAsString(this.entry.item_1.amount.net)
        },

        correction () {
            if (!this.entry.item_1) {
                return "---";
            }

            return this.moneyAsString(this.entry.item_1.correction.net)
        },
    },
}


</script>

<style scoped>

.amount, .correction {
    width: 40%;
    text-align: right;
}

.amount, .correction, .elevator {
    font-size: 15px;
    padding-top: 5px;
}

</style>